module.exports = __webpack_public_path__ + "1731b5720a850bf2a5e736dfd86e62e8.svg";